export const ApiUrl = {
  getLanguages: '/api/languages',
  getProductTypes: '/api/menu/product-types',
  getProductsMenu: '/api/menu/products',
  getMenu: '/api/menu',
  getCategoryTypes: '/api/menu/category-types',
  getCategoryTypesList: '/api/menu/category-types-list',
  getSpecialOffersList: '/api/menu/special-offers',

  getProductsDigitalBanking: (slug: number | string) =>
    `/api/products/digital-banking/${slug}`,
  getProductsDetails: (id: number) => `/api/products/details/${id}`,
  getProductsSpecialOffer: (slug: number | string) =>
    `/api/products/special-offer/${slug}`,
  getProductsMoreCategories: `/api/products/more/categories`,
  getProductsMoreDetails: (slug: number | string) =>
    `/api/products/more/${slug}`,

  getLoansTypes: '/api/loans/types',
  getLoansAll: '/api/loans/all',
  getLoan: (slug: number | string) => `/api/loans/${slug}`,
  getLoansCalculators: '/api/loans/calculators',
  getLoansConstructors: (slug: number | string) =>
    `/api/loans/developer/${slug}`,

  getDepositsAll: '/api/deposits/all',
  getDepositsInsividualAll: '/api/deposits/individual-all',
  getDeposit: (slug: number | string) => `/api/deposits/${slug}`,
  getDepositsCalculators: '/api/deposits/calculators',

  getCardsFilters: '/api/cards/filters',
  getCardsTypes: '/api/cards/types',
  getCardsAll: '/api/cards/all',
  getCard: (slug: number | string) => `/api/cards/${slug}`,

  getAccountsAll: '/api/accounts/all',
  getAccount: (slug: number | string) => `/api/accounts/${slug}`,

  getPackagesAll: '/api/packages/all',
  getPackage: (slug: number | string) => `/api/packages/${slug}`,

  getBankomats: '/api/pages/bankomats',
  getBranches: '/api/pages/branches',
  getContactPage: '/api/pages/contact',
  getAnnouncementsPage: '/api/pages/announcements',
  getAnnouncementsItems: '/api/pages/announcements-items',
  getAnnouncementsFilters: '/api/pages/announcements-filters',
  getAnnouncement: (slug: number | string) =>
    `/api/pages/announcements/${slug}`,
  getBondPage: '/api/pages/bond',
  getShoppingPage: '/api/pages/shopping',
  getBondAnnouncementsPage: '/api/pages/bond-announcements',
  getShareholdersInvestorsPage: '/api/pages/shareholders-investors',
  getCorporateManagementPage: '/api/pages/corporate-management',
  getReportsPage: '/api/pages/reports',
  getUsefulLinksPage: '/api/pages/useful-links',
  getCareersPage: '/api/pages/careers',
  getCareer: (slug: number | string) => `/api/pages/careers/${slug}`,
  getCareerPageContent: '/api/pages/career-content',
  getAlienablePropertiesPage: '/api/pages/alienable-properties',
  getCorporateSocialResponsibilityPage:
    '/api/pages/corporate-social-responsibility',
  getBrandResourcesPage: '/api/pages/brand-resources',
  getPricesPage: '/api/pages/tariff',
  getPricesArchivePage: '/api/pages/tariff-archive',
  getAboutUsPage: '/api/pages/all-about-us',
  getAdviceGuidancePage: '/api/pages/advice-guidance',
  getChronologyPage: '/api/pages/chronology',
  getCalculatorsPage: '/api/pages/calculators',
  getSustainableDevelopmentPage: '/api/pages/sustainable-development',
  getHomePage: '/api/home',
  getCurrencyRates: '/api/pages/currency-rates',
  getExchangeRates: '/api/pages/exchange-rates',
  getRegulations: '/api/pages/legal-acts',
  getTermsOfServices: '/api/pages/bank-services-terms-conditions',
  getConsumerRights: '/api/pages/consumer-rights',
  getCompliancePage: '/api/pages/compliance',
  getHistoricalDetails: '/api/pages/historical-details',
  getTraineePage: '/api/pages/trainee',
  postTraineeApplication: '/api/pages/trainee/send-form',

  sendContactFrom: '/api/pages/contacts/send-form',
  sendCareerBid: '/api/pages/careers/send-bid',
  sendCareerHrBid: '/api/pages/careers-other/send-bid',
  checkBrandResourcePassword: '/api/pages/brand-resources/check-password',
  convertExcel: '/api/pages/convert-excel',
  getDepositCalculatorRates: (id: number) => `/api/pages/deposits/${id}`,

  getNewsAll: '/api/news/all',
  getNewsCategories: '/api/news/categories',
  getNewsItem: (slug: number | string) => `/api/news/${slug}`,
  postNewsSubsciption: '/api/subscribers',

  getBlogsAll: '/api/blogs/all',
  getBlogsCategories: '/api/blogs/categories',
  getBlogsItem: (slug: number | string) => `/api/blogs/${slug}`,

  getOnlineApplicationsPage: '/api/online-applications/types-all',
  getOnlineApplicationsRequest: '/api/online-applications/request',
  getOnlineApplication: (slug: number | string) =>
    `/api/online-applications/${slug}`,
  getOnlineApplicationSpecial: (slug: number | string) =>
    `/api/online-applications/special/${slug}`,
  postOnlineApplicationsForm: '/api/online-applications/send-form',
  postOnlineApplicationSpecialForm:
    '/api/online-applications/special/send-form',

  getInvestContent: '/api/invest/content',
  getInvestManagement: '/api/invest/management',
  getInvestInvestor: '/api/invest/investor',
  getInvestResults: '/api/invest/results',
  postInvestContact: '/api/invest/send-form',

  getSelectLandingPage: '/api/select-landing',
  getSelectLandingSpecialOffers: '/api/select-landing/special-offers',
  postSelectLandingSpecialOffersFilters: '/api/select-landing/filters',
  getSelectLandingSpecialOfferBySlug: (slug: string | number) =>
    `/api/select-landing/special-offers/${slug}`,
  postSelectLandingApplication: '/api/select-landing/send-form',

  getPromoLandings: '/api/promo-landings',
  getPromoLandingBySlug: (slug: string | number) =>
    `/api/promo-landings/${slug}`,
  postPromoLandingApplication: '/api/promo-landings/send-form',
};
